/*
 * @Date: 2019-12-08 17:13:38
 * @LastEditors: miaomiaodeng
 * @LastEditTime: 2020-03-11 16:52:10
 * @FilePath: /rongxin.web/src/views/home/index.js
 */
// component
import Navbar from '../../../components/navbar/index.vue';
import ProductService from '../../home/product-service/index.vue';
import contactUs from '../../home/contact-us/index.vue';
import Servece from './servece.js';
export default {
  name: 'home',
  components: {
    Navbar,
    ProductService,
    contactUs
  },
  data() {
    return {
      fromisActiveClass: 'mediaReports',
      id: '',
      details: {}
    };
  },
  created() {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.getNewsDetail(this.id);
  },
  methods: {
    goHome() {
      this.$router.push({path: 'home'});
    },
    getNewsDetail(id) {
      Servece.getNewsDetail(id).then(res => {
        this.details = {
          ...res.data
        };
      });
    }
  }
};
